<template>
  <v-dialog :value="dialog" @input="onClose" max-width="800px">
    <v-card>
      <v-card-title class="title">
        <v-layout row wrap>
          <v-flex xs12 sm8 mb-2>
            <template v-if="broadcast">
              <span>{{ $t('message.sendMessageAllClients') }}</span>
            </template>
            <template v-else>
              <v-layout v-if="client">
                <v-flex>
                  <span class="title mx-2">
                    {{ $t('message.client') }}:
                    <strong>{{ client.name }} {{ client.lastname }}</strong>
                  </span>
                </v-flex>
              </v-layout>
            </template>
          </v-flex>
          <v-spacer></v-spacer>
          <v-chip
            v-if="!!imageFile"
            :value="true"
            @input="removeImage"
            label
            close
            color="primary"
            outline
          >{{ imageFile.name.slice(0, 20) }}</v-chip>
          <ValidationProvider
            v-bind:class="{'d-none': !!imageFile}"
            name="image"
            ref="myInput"
            rules="required"
            v-slot="{ validate, errors}"
          >
            <v-input :error-messages="errors">
              <v-btn block outline @click="$refs.imageInput.click()" color="primary">
                <v-icon class="mx-2">zmdi-plus</v-icon>
                <span>{{ $t('message.addImage') }}</span>
              </v-btn>
              <input
                @change="saveImage($event) || validate($event)"
                key="send-image"
                ref="imageInput"
                class="d-none"
                type="file"
              />
            </v-input>
          </ValidationProvider>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <v-form>
          <v-container>
            <v-layout align-center justify-center row wrap>
              <v-flex xs12>
                <v-textarea
                  :counter="true"
                  :error-messages="errors.collect('message')"
                  data-vv-name="message"
                  :label="$t('message.message')"
                  v-model="message"
                  v-validate="'required|max:240'"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="onClose" outline color="error">{{ $t('message.close') }}</v-btn>
        <v-btn
          outline
          :disabled="sendingMessage"
          :loading="sendingMessage"
          @click="onSend"
          color="primary"
        >
          <span>{{ $t('message.send') }}</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import {
  SEND_MESSAGE,
  SEND_IMAGE,
  BROADCAST_MESSAGE,
  BROADCAST_IMAGE
} from "../../store/modules/telegramBot/actions.type";
import { ValidationProvider } from "vee-validate";

export default {
  name: "userManage",
  components: {
    ValidationProvider
  },
  props: {
    dialog: {
      required: false,
      default: false
    },
    broadcast: {
      required: false,
      default: false
    },
    broadcastWeb: {
      required: false,
      default: false,
    }
  },
  data() {
    return {
      client: null,
      message: null,
      withImage: false,
      imageFile: null,
      web: false
    };
  },
  computed: {
    ...mapGetters({
      sendingMessage: "sendingMessage"
    })
  },
  methods: {
    async broadcastMessage() {
      try {
        const valid = await this.$validator.validateAll();
        if (valid) {
          this.$store.dispatch(BROADCAST_MESSAGE, {
            text: this.message,
            storeId: this.broadcastWeb ? this.$store.getters.store.id : null
          });
        }
        this.onClose();
      } catch (err) {
        console.error(err);
      }
    },
    async broadcastImage() {
      try {
        const valid = await this.$validator.validateAll();
        const validImage = await this.$refs.myInput.validate();
        if (valid && validImage) {
          this.$store.dispatch(BROADCAST_IMAGE, {
            text: this.message,
            image: this.imageFile,
            storeId: this.broadcastWeb ? this.$store.getters.store.id : null
          });
        }
        this.onClose();
      } catch (err) {
        console.error(err);
      }
    },
    onClose() {
      this.$emit("update:dialog", false);
      this.client = null;
      this.message = null;
      this.imageFile = null;
      this.withImage = false;
      this.$validator.reset();
        this.removeImage();
        this.$refs.myInput.reset();
    },
    onSend() {
      if (this.broadcast) {
        if (this.withImage) {
          this.broadcastImage();
        } else {
          this.broadcastMessage();
        }
      } else {
        if (this.withImage) {
          this.sendImage();
        } else {
          this.sendMessage();
        }
      }
    },
    removeImage() {
      this.$refs.imageInput.value = null;
      this.imageFile = null;
      this.withImage = false;
    },
    saveImage(imageFile) {
      if (imageFile.target.files[0]) {
        this.imageFile = imageFile.target.files[0];
        this.withImage = true;
      }
    },
    setValue(client, web = false) {
      this.client = client;
      this.web = web;
    },
    async sendMessage() {
      try {
        const valid = await this.$validator.validateAll();
        if (valid) {
          await this.$store.dispatch(SEND_MESSAGE, {
            clientId: this.client.id,
            text: this.message,
            storeId: this.web ? this.$store.getters.store.id : null
          });

          this.onClose();
        }
      } catch (err) {
        console.error(err);
      }
    },
    async sendImage() {
      try {
        const valid = await this.$validator.validateAll();
        const validImage = await this.$refs.myInput.validate();
        if (valid && validImage) {
          await this.$store.dispatch(SEND_IMAGE, {
            clientId: this.client.id,
            text: this.message,
            image: this.imageFile,
            storeId: this.web ? this.$store.getters.store.id : null
          });

          this.onClose();
        }
      } catch (err) {
        console.error(err);
      }
    }
  }
};
</script>

<style scoped>
</style>
